import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';

import { authContext } from '../../routes';
import axiosInstance from '../../api';
import CustomSnackbar from '../../components/alerts/CustomSnackbar';
import SERVER_API_URL from '../../config';
import { Searchbar } from '../../components/searchbar';
import RoleAccordion from './RoleAccordion';

export default function RoleList({ setUserToBeUpdated, setRoleActivatedOn }) {
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [changed, setChanged] = useState({});
  const [notification, setNotification] = useState({});
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const { user } = useContext(authContext);
  const containerRef = useRef(null);

  const handelRef = () => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const getPermissions = useCallback(async () => {
    try {
      const response = await axiosInstance.post(`${SERVER_API_URL}/role/findAll`);

      
      if (response.status === 200) {
        const comingRoles = response.data.filter((role)=>role.id !== user.role.id)
        const initialRoles = comingRoles.reduce((acc, role) => {
          const rolePermissions = role.privileges.map((permission) => ({
            id: permission.id,
            resourceName: permission.resource.name,
            amhName: permission.resource.amhName,
            resourceDescription: permission.resource.description,
            read: permission.read,
            create: permission.create,
            update: permission.update,
            delete: permission.delete,
          }));
          acc.push({
            id: role.id,
            roleName: role.name,
            description: role.description,
            permissions: rolePermissions,
            createdAt: role.createdAt,
            updatedAt: role.updatedAt,
            users: role.users,
            changed: false,
          });
          return acc;
        }, []);
        setRoles(initialRoles);
        setPermissions(initialRoles);
      }
    } catch (e) {
      // console.log(e);
    }
  }, [user, setRoles, setPermissions]);

  useEffect(() => {
    getPermissions();
  }, [getPermissions]);

  useEffect(() => {
    const all = roles;
    setPermissions(query ? all.filter((role) => role.roleName.toLowerCase().includes(query.toLowerCase())) : all);
  }, [query, roles]);

  const handleSave = async (roleId) => {
    setLoading(true);
    try {
      const rolePermission = permissions
        .find((permission) => permission.id === roleId)
        .permissions.map((permission) => ({
          id: permission.id,
          read: permission.read,
          create: permission.create,
          update: permission.update,
          delete: permission.delete,
        }));

      const response = await axiosInstance.put(`${SERVER_API_URL}/role/updatePermission/${user.id}`, rolePermission);
      if (response.status === 200) {
        notification.message = 'ለውጦች በተሳካ ሁኔታ ተቀምጠዋል።';
        notification.severity = 'success';
        const newChanged = { ...changed };
        newChanged[roleId] = false;
        setChanged(newChanged);
      }
    } catch (e) {
      notification.message = 'ለውጦችን ማስቀመጥ አልተቻለም። እባክዎ ዳግም ይሞክሩ!';
      notification.severity = 'error';
    }
    setNotification(notification);
    setLoading(false);
  };

  const handleUserInfo = async (roleId) => {
    try {
      const response = await axiosInstance.post(`${SERVER_API_URL}/user/findManyByRoleId/${roleId}`);
      if (response.status === 200) {
        setUserToBeUpdated(response.data);
        setRoleActivatedOn('userList');
      }
    } catch (error) {
      // console.log(error)
    }
  };

  return (
    <>
      {notification.message && <CustomSnackbar notification={notification} setNotification={setNotification} />}

      <Searchbar setQuery={setQuery} />

      <Box ref={containerRef} sx={{
        boxShadow: (theme) => `
                                  -8px -8px 10px ${alpha(theme.palette.primary.darker, 0.1)},
                                  8px 8px 5px ${alpha(theme.palette.primary.darker, 0.15)}
                                `}}>
        <RoleAccordion
          allRole={permissions}
          setAllRole={setPermissions}
          user={user}
          handleSave={handleSave}
          handleUserInfo={handleUserInfo}
          changed={changed}
          setChanged={setChanged}
          loading={loading}
          handelRef={handelRef}
        />
      </Box>
    </>
  );
}

RoleList.propTypes = {
  setUserToBeUpdated: PropTypes.object,
  setRoleActivatedOn: PropTypes.func,
};
